import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { IntegrationsClientModule } from './client/integrations-client.module';
import { InitialRouteHandlerService, SCOPED_LOCALSTORAGE_PROVIDER } from './common';
import { IntegrationEventEffects } from './common/events/events.effects';

export function appInitializerFactory(
  initialRouteHandlerService: InitialRouteHandlerService,
): () => void {
  // https://medium.com/@thilanka.nuwan89/angular-lambda-not-supported-error-work-around-8f204f4cad9a
  const listener = function (): void {
    initialRouteHandlerService.init();
  };
  return listener;
}

@NgModule({
  imports: [IntegrationsClientModule, EffectsModule.forFeature([IntegrationEventEffects])],
  exports: [IntegrationsClientModule],
})
export class RtiIntegrationsModule {
  public static forRoot(): ModuleWithProviders<RtiIntegrationsModule> {
    return {
      ngModule: RtiIntegrationsModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = appInitializerFactory(inject(InitialRouteHandlerService));
          return initializerFn();
        }),
        SCOPED_LOCALSTORAGE_PROVIDER,
      ],
    };
  }
}
